import { Injectable } from '@angular/core';
import { Config } from '../_store';
import { CurrencyDisplayService } from './currency-display.service';

@Injectable({
  providedIn: 'root'
})
export class PostProcessHttpResponseCurrencyService {
  private currDefaults = {
    code: Config.defaultCurr,
  }

  constructor(
    private currencyDisplayService: CurrencyDisplayService
  ) { }

  private getCurrAmtDetails(obj, valField, currField) {
    try {
      const currObj = {
        dispalyStr: '',
        // Display each amount in its own currency (from the record's currCode),
        // falling back to the app default when the record has none.
        amts: [{ amt: obj[valField], curr: obj[currField] || this.currDefaults.code, formattedAmt: '' }]
      };
      currObj.amts.forEach(amt => {
        amt.formattedAmt = this.currencyDisplayService.getFormattedCurrencyStr(amt);
      });
      currObj.dispalyStr = currObj.amts.map(amt => amt.formattedAmt).join(', ');
      return currObj;
    } catch (err) {
      console.log(obj, err);
    }
  }

  processInvoice(inv) {
    // if (inv.docNo === 'DN24342307') {
    //   inv.currCode = 'INR';
    // }
    inv.docAmtDetails = this.getCurrAmtDetails(inv, 'docAmt', 'currCode');
    inv.dueAmtDetails = this.getCurrAmtDetails(inv, 'dueAmt', 'currCode');
  }

  processPayment(trans) {
    trans.tranAmtDetails = this.getCurrAmtDetails(trans.tranAmt, 'amt', 'currCode');
    trans.bankAmtDetails = this.getCurrAmtDetails(trans.tranAmt, 'bankAmt', 'currCode')
  }

  processPaymentCreditNotes(creditNote) {
    creditNote.docAmtDetails = this.getCurrAmtDetails(creditNote.docAmt[0], 'amt', 'currCode');
  }

  processCreditNotes(creditNote) {
    // docAmt is an array [{ amt: number, currCode: string }], so we need to extract the amount from the first element
    if (creditNote.docAmt && Array.isArray(creditNote.docAmt) && creditNote.docAmt.length > 0) {
      const docAmtObj = creditNote.docAmt[0];
      creditNote.docAmtDetails = this.getCurrAmtDetails(docAmtObj, 'amt', 'currCode');
    } else if (creditNote.docAmt && typeof creditNote.docAmt === 'number') {
      // Fallback: if docAmt is a number, use it directly
      creditNote.docAmtDetails = this.getCurrAmtDetails(creditNote, 'docAmt', 'currCode');
    } else {
      creditNote.docAmtDetails = this.getCurrAmtDetails(creditNote, 'docAmt', 'currCode');
    }
    
    // dueAmt is typically a number, but handle array case too
    if (creditNote.dueAmt && Array.isArray(creditNote.dueAmt) && creditNote.dueAmt.length > 0) {
      const dueAmtObj = creditNote.dueAmt[0];
      creditNote.dueAmtDetails = this.getCurrAmtDetails(dueAmtObj, 'amt', 'currCode');
    } else {
      creditNote.dueAmtDetails = this.getCurrAmtDetails(creditNote, 'dueAmt', 'currCode');
    }
  }

  processPaymentDetails(trans) {
    trans.apprvAmtDetails = this.getCurrAmtDetails(trans, 'apprvAmt', 'currCode');
    trans.bankAmtDetails = this.getCurrAmtDetails(trans, 'bankAmt', 'currCode');
    trans.CNAmtDetails = this.getCurrAmtDetails(trans, 'CNAmt', 'currCode');
  }

  processInvoicesForPayment(inv) {
    inv.dueAmtDetails = this.getCurrAmtDetails(inv, 'dueAmt', 'currCode');
  }

}
